module.exports = __webpack_public_path__ + "static/media/ic-arrow.d42fd1eb.svg";